/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}@media (max-width:767px){  .nav-pills{display:list-item}}  .nav-pills .nav-item .nav-link{text-transform:uppercase;color:#e3a300}  .nav-pills .nav-item .nav-link.active{background-color:#e3a300;color:#fff}"];
export { styles as styles };
